// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.category-filter {
    border: 1px solid rgb(36, 42, 101);
    border-radius: 8px;
    margin: 10px;
}

.category-filter-header {
    cursor: pointer;
    padding-left: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.category-filter-header h5 {
    line-height: 2px;
}

.category-filter-body {
    overflow: hidden;
    max-height: 0;
    opacity: 0;
    transition: max-height 0.25s ease, opacity 0.25s ease;
}

.category-filter-body.expanded {
    opacity: 1;
    padding: 1rem;
    color: white;
    max-height: 400px;
    overflow-y: auto;
    padding-right: 8px;
    scrollbar-gutter: stable;
}

ul {
    list-style: none;
    padding-left: 0;
}
li {
    margin-bottom: 6px;
}
li.active button {
    color: #00baff;
    font-weight: bold;
}
button {
    background: none;
    border: none;
    color: inherit;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    align-items: center;
}
.bullet {
    width: 6px;
    height: 6px;
    background: #00baff;
    border-radius: 50%;
    display: inline-block;
    margin-right: 6px;
}
.count {
    margin-left: 4px;
    color: rgba(255,255,255,0.5);
}
.category-name {
    cursor: pointer;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 0;
}

.subcategory-list {
    padding-left: 10px;
}

.subcategory-list li button {
    max-width: 330px;
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.subcategory-list li button .bullet {
    flex-shrink: 0;
    margin-right: 4px;
}

.subcategory-list li button .count {
    flex-shrink: 0;
}

.expand-toggle {
    font-size: 12px;
}

.category-pick-button {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 12px;
    opacity: 0.6;
    transition: opacity 0.2s;
    display: inline-flex;
}

.category-pick-button:hover {
    opacity: 1;
}

.category-pick-button.active {
    font-weight: bold;
    color: #3a86ff;
    opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/CategoryFilter.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,UAAU;IACV,qDAAqD;AACzD;;AAEA;IACI,UAAU;IACV,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,4BAA4B;AAChC;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,YAAY;IACZ,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,UAAU;AACd","sourcesContent":[".category-filter {\n    border: 1px solid rgb(36, 42, 101);\n    border-radius: 8px;\n    margin: 10px;\n}\n\n.category-filter-header {\n    cursor: pointer;\n    padding-left: 15px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.category-filter-header h5 {\n    line-height: 2px;\n}\n\n.category-filter-body {\n    overflow: hidden;\n    max-height: 0;\n    opacity: 0;\n    transition: max-height 0.25s ease, opacity 0.25s ease;\n}\n\n.category-filter-body.expanded {\n    opacity: 1;\n    padding: 1rem;\n    color: white;\n    max-height: 400px;\n    overflow-y: auto;\n    padding-right: 8px;\n    scrollbar-gutter: stable;\n}\n\nul {\n    list-style: none;\n    padding-left: 0;\n}\nli {\n    margin-bottom: 6px;\n}\nli.active button {\n    color: #00baff;\n    font-weight: bold;\n}\nbutton {\n    background: none;\n    border: none;\n    color: inherit;\n    cursor: pointer;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n}\n.bullet {\n    width: 6px;\n    height: 6px;\n    background: #00baff;\n    border-radius: 50%;\n    display: inline-block;\n    margin-right: 6px;\n}\n.count {\n    margin-left: 4px;\n    color: rgba(255,255,255,0.5);\n}\n.category-name {\n    cursor: pointer;\n    font-weight: 600;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 4px 0;\n}\n\n.subcategory-list {\n    padding-left: 10px;\n}\n\n.subcategory-list li button {\n    max-width: 330px;\n    display: inline-flex;\n    align-items: center;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.subcategory-list li button .bullet {\n    flex-shrink: 0;\n    margin-right: 4px;\n}\n\n.subcategory-list li button .count {\n    flex-shrink: 0;\n}\n\n.expand-toggle {\n    font-size: 12px;\n}\n\n.category-pick-button {\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 12px;\n    opacity: 0.6;\n    transition: opacity 0.2s;\n    display: inline-flex;\n}\n\n.category-pick-button:hover {\n    opacity: 1;\n}\n\n.category-pick-button.active {\n    font-weight: bold;\n    color: #3a86ff;\n    opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
